import axiosInstance from '../../lib/axios';
import { cancellableGet } from '../../lib/cancellableGet';

/** Support lead console: cross-user, admin-only, read-shaped bar one soft delete. */
const ROOT = '/admin/support';

// Bare object. Support-wide counts, not the caller's threads.
export const fetchSupportOverview = () => cancellableGet(`${ROOT}/overview/`);

// Paginated envelope, longest wait first.
export const fetchLiveQueue = ({ queue = 'general', page = 1, limit = 50 } = {}) =>
  cancellableGet(`${ROOT}/live-queue/`, {
    params: { queue, page, limit },
  });

// Also accepts agent_id, date_from and date_to; unsent until a control sets them.
export const fetchSupportArchive = ({
  q,
  filter,
  queue = 'general',
  page = 1,
  limit = 50,
} = {}) => {
  const params = { queue, page, limit };
  if (q) params.q = q;
  if (filter && filter !== 'all') params.filter = filter;
  return cancellableGet(`${ROOT}/conversations/`, { params });
};

// 204, no body. Soft delete - the row stays, every read path skips it.
export const deleteSupportConversation = async (conversationId) => {
  await axiosInstance.delete(`${ROOT}/conversations/${conversationId}/`);
  return conversationId;
};

// { success, data: [] } with no page meta. Each metric carries the server's own colour.
export const fetchAgentsMetric = () => cancellableGet(`${ROOT}/agents-metric/`);

// Bare object: a week of issue categories, the totals row, and at most one alert.
export const fetchIssueTrends = () => cancellableGet(`${ROOT}/issues/`);
